import { trackEvent } from "@amplio-common/analytics";

export const overrideWSSendMethod = (websocket) => { // safe weboskcet.send - waits for WS to be open (override given ws)
  const wsSend = websocket.send;
  websocket.pendingMessages = [];

  const waitForOpenConnection = () => new Promise((resolve, reject) => {
    const maxNumberOfAttempts = 200;
    const intervalTime = 200; //ms
    let currentAttempt = 0;

    const tryConnection = () => {
      if (currentAttempt >= maxNumberOfAttempts) {
        trackEvent("ws_pending_connect_send_failed");
        return reject(new Error("WS Pending Connect - Maximum number of attempts exceeded - stopping"));
      }

      if (websocket.readyState === WebSocket.OPEN) {
        return resolve();
      }

      currentAttempt += 1;
      setTimeout(tryConnection, intervalTime);
    };

    tryConnection(); // Start the first attempt
  });

  const newWSSend = async (data) => {
    if (websocket.readyState === websocket.OPEN) {
      try { wsSend.apply(websocket, [data]); } catch (e) { console.error(`websocket send error ${e}`); }
      return;
    }
    
    websocket.pendingMessages.push(data);
    try {
      await waitForOpenConnection();
      // wsSend.apply(websocket, [data]);
      websocket.pendingMessages.forEach(msg => wsSend.apply(websocket, [msg]));
      websocket.pendingMessages = [];
    } catch (err) { console.error(err); }
  };

  websocket.send = newWSSend;
  websocket.sendJson = (jsonMsg) => websocket.send(JSON.stringify(jsonMsg));
};
